"use client";
// Import individual filter components here as they are created
import SourceOptionsFilter from "./FilterSection/SourceOptionFilter";
import CandidateSourceOptionsFilter from "./FilterSection/CandidateSourceOptionsFilter";
import JobTitlesFilter from "./FilterSection/JobTitlesFilter";
import SectorFilter from "./FilterSection/SectorFilter";
import SkillsFilter from "./FilterSection/SkillsFilter";
import ResidencyFilter from "./FilterSection/ResidencyFilter";
import QualificationsFilter from "./FilterSection/QualificationsFilter";
import GenderFilter from "./FilterSection/GenderFilter";
import ListedCompaniesFilter from "./FilterSection/ListedCompaniesFilter";
import MoreFiltersSection from "./FilterSection/MoreFiltersSection";
import { usePowerSearch } from "./contexts/power-search-context";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useRef, useEffect, useState } from "react";
import { useFullScreen } from "./contexts/FullScreenProvider";
import { useSelector } from "react-redux";
import { mixpanelTrack } from "shared/trackEvents/mixpanelTracking";
import { isOpenRemunerationPlan } from "shared/plans";
import {
  POWER_SEARCH_EVENT_NAMES,
  MIXPANEL_PROPS,
} from "shared/trackEvents/constants";

const ApplyFiltersButton = ({ handleApplyFilters, searchResultsLoading }) => {
  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>Apply Filters</Tooltip>}>
      <Button
        type="submit"
        variant="primary"
        size="sm"
        onClick={handleApplyFilters}
        style={{
          borderRadius: "50%",
          width: "32px",
          height: "32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0",
          border: "1px solid #dee2e6",
        }}
        title="Hide Apply Filters"
      >
        {searchResultsLoading ? (
          <i className="fa fa-spinner fa-spin" style={{ fontSize: "10px" }}></i>
        ) : (
          <i className="fa fa-filter" style={{ fontSize: "10px" }}></i>
        )}
      </Button>
    </OverlayTrigger>
  );
};

const SearchFilters = () => {
  const { isFullScreen } = useFullScreen();
  const currentUser = useSelector((state) => state.users.user);

  const searchFilterRef = useRef(null);
  const [searchFilterWidth, setSearchFilterWidth] = useState(0);

  const { clearAllFilters, filterOptions, searchResultsLoading } =
    usePowerSearch();

  const handleApplyFilters = () => {
    console.log("Apply Filters");

    // Track apply filter click
    const eventName = isOpenRemunerationPlan(currentUser)
      ? POWER_SEARCH_EVENT_NAMES.OR_POWER_SEARCH_APPLY_FILTER_CLICKED
      : POWER_SEARCH_EVENT_NAMES.OD_POWER_SEARCH_APPLY_FILTER_CLICKED;

    mixpanelTrack(eventName, {
      userEmail: currentUser?.email,
    });
  };

  useEffect(() => {
    if (searchFilterRef.current) {
      setSearchFilterWidth(searchFilterRef.current.offsetWidth);
    }
  }, []);

  return (
    <div ref={searchFilterRef} style={{ position: "relative" }}>
      {/* Header with Clear button */}
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ marginBottom: "16px" }}
      >
        <Button
          variant="link"
          size="sm"
          onClick={clearAllFilters}
          style={{ padding: 0 }}
        >
          Clear all
        </Button>
        <Button
          variant="primary"
          type="submit"
          size="sm"
          onClick={handleApplyFilters}
          style={{ fontSize: "12px" }}
          disabled={searchResultsLoading}
        >
          Apply Filters
        </Button>
      </div>
      {/* Filters Container */}
      <div
        className="all-filters-container"
        style={{
          position: "relative",
          minHeight: "100vh",
        }}
      >
        <SourceOptionsFilter />
        <div style={{ height: "14px" }} />
        <CandidateSourceOptionsFilter />
        <div style={{ height: "14px" }} />
        <JobTitlesFilter />
        <div style={{ height: "14px" }} />
        <SectorFilter />
        <div style={{ height: "14px" }} />
        <SkillsFilter />
        <div style={{ height: "14px" }} />
        <ResidencyFilter />
        <div style={{ height: "14px" }} />
        <QualificationsFilter />
        <div style={{ height: "14px" }} />
        <GenderFilter />
        <div style={{ height: "10px" }} />
        <ListedCompaniesFilter />
        <div style={{ height: "10px" }} />
        <MoreFiltersSection />
        <div
          style={{
            position: "fixed",
            bottom: "10%",
            left: isFullScreen
              ? `calc(${searchFilterWidth}px + 10px)`
              : `calc(${searchFilterWidth}px + 140px)`,
            zIndex: 1000,
          }}
        >
          <ApplyFiltersButton
            handleApplyFilters={handleApplyFilters}
            searchResultsLoading={searchResultsLoading}
          />
        </div>{" "}
      </div>
    </div>
  );
};

export default SearchFilters;
